import * as React from "react";
import {cx} from "emotion";

import "./imb-base.scss";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {fragments}        from "@Common/react/fragments";
import {Load2}            from "@Common/react/load2";
import {OnUnmounted}      from "@Common/react/on-unmounted";
import {Static2}          from "@Common/react/static-2";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {Editing} from "./editing/editing";
import {Viewing} from "./viewing/viewing";

export const ImbBase = ({enabled, agentId=undefined, next: rootNext}) => cs(
    ["editing", (_, next) => Editing({agentId, next})],
    ["box", (_, next) => Box({next})],

    // ["idMailClass", (_, next) => UseState({
    //     initValue: initIdMailClass,
    //     defaultValue: "1",
    //     next,
    // })],

    consumeContext("apis"),
    ["saved", ({apis}, next) => Load2({
        _key: enabled,
        fetch: () => !enabled ? null : apis.next.imb.getMailerId({agentId}),
        next,
    })],
    ({editing, saved, box}) => rootNext({
        loading: saved.loading,
        valid: !editing.active && saved.value,
        "idMailer": saved.value?.idMailer,
        // persistData: saved.value && ({
        //     "idMailer": saved.value.idMailer,
        //     "idMailClass": idMailClass.value,
        // }),
        highlightErrors: () => {
            box.highlightErrors();
        },
        render: ({showErrors, idMailClass, className}) => cs(
            ({}, next) => fragments(
                next(),
                OnUnmounted({
                    action: () => {
                        if (editing.active) {
                            editing.deactivate();
                        }
                    },
                }),
            ),
            ({}, next) => box.render({className, next}),
            () => editing.active ? (
                editing.render({saved})
            ) : (
                Viewing({
                    idMailer: saved.value?.idMailer,
                    idMailClass,
                    showErrors,
                    onEdit: editing.activate,
                })
            ),
        ),
    }),
);

const Box = ({next: rootNext}) => cs(

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ({eh, domRef}) => rootNext({
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
        },
        render: ({className, next}) => (
            <div className={cx("box", eh.css, className)} ref={domRef.set}>
                {next()}
            </div>
        ),
    })
);
